export default __webpack_public_path__ + "static/media/fb_icon.2b9e8b7e.svg";